const tags = [
  "+4 anos de experiência",
  "Blumenau/SC",
  "Atendimento por videoconferência",
  "Suporte humano via WhatsApp",
  "Renovação facilitada por até 10 anos",
];

export default function Hero() {
  return (
    <section
      id="inicio"
      className="relative overflow-hidden bg-background-50 pt-28 pb-16 md:pt-36 md:pb-20 lg:pt-40 lg:pb-24"
    >
      {/* Background decorative blobs */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-500/5 blur-3xl -translate-y-1/3 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full bg-accent-500/5 blur-3xl translate-y-1/3 -translate-x-1/4" />

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-accent-50 border border-accent-200 px-3 py-1.5 text-xs text-accent-700 font-medium">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500 animate-pulse" />
              Certificação digital ICP-Brasil
            </div>

            <h1 className="mt-5 text-4xl md:text-5xl lg:text-[3.5rem] text-foreground-950 leading-[1.06] font-heading">
              Seu{" "}
              <span className="text-primary-500">
                Certificado Digital
              </span>{" "}
              com atendimento humano
            </h1>

            <p className="mt-4 text-lg text-foreground-600 leading-relaxed">
              e-CPF e e-CNPJ 100% online por videoconferência. Uma equipe de
              verdade te acompanha do início ao fim.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="#certificados"
                className="group inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3.5 text-background-50 font-medium hover:bg-primary-600 transition-all whitespace-nowrap shadow-sm shadow-primary-500/20"
              >
                <i className="ri-shield-check-line text-lg"></i>
                Escolher meu certificado
              </a>
              <a
                href="https://wa.me/5547991891311"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-secondary-300 bg-background-50 px-6 py-3.5 text-foreground-700 font-medium hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                Falar no WhatsApp
              </a>
            </div>

            <ul className="mt-7 flex flex-wrap gap-2">
              {tags.map((tag) => (
                <li
                  key={tag}
                  className="inline-flex items-center gap-1.5 rounded-full bg-background-100 border border-secondary-200/60 px-3 py-1.5 text-xs text-foreground-600"
                >
                  <i className="ri-check-line text-accent-500 text-xs"></i>
                  {tag}
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Abstract visual */}
          <div className="hidden lg:flex items-center justify-center relative">
            <div className="relative w-80 h-80">
              {/* Decorative circles */}
              <div className="absolute inset-0 rounded-full border-2 border-dashed border-primary-300/40 animate-[spin_60s_linear_infinite]" />
              <div className="absolute inset-8 rounded-full border border-accent-400/20" />
              <div className="absolute inset-16 rounded-3xl bg-primary-500/8 flex items-center justify-center">
                <i className="ri-shield-check-line text-7xl text-primary-400/30"></i>
              </div>

              {/* Floating badges */}
              <div className="absolute -top-3 right-6 rounded-xl bg-background-50 border border-secondary-200 px-3 py-2 shadow-sm flex items-center gap-2">
                <i className="ri-check-double-line text-accent-500"></i>
                <span className="text-xs font-medium text-foreground-700">
                  ICP-Brasil
                </span>
              </div>
              <div className="absolute -bottom-2 left-2 rounded-xl bg-background-50 border border-secondary-200 px-3 py-2 shadow-sm flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-500"></i>
                <span className="text-xs font-medium text-foreground-700">
                  Soluti
                </span>
              </div>
              <div className="absolute top-1/2 -right-10 rounded-xl bg-background-50 border border-secondary-200 px-3 py-2 shadow-sm flex items-center gap-2">
                <i className="ri-user-heart-line text-accent-500"></i>
                <span className="text-xs font-medium text-foreground-700">
                  Atendimento humano
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}